import ActionsForm from '@/shared/mixins/actionsForm'
import qmaTemplateCabecalho from '@/shared/http/repositories/business/qmaTemplateHeader'
import { toast, loading } from '@/shared/utils/UIHelper'
// import IconCampoGrande from '../../../../../../../../../static/img/qma/IconCampoGrande.svg'
import IconCampoPequeno from '../../../../../../../../../static/img/qma/IconCampoPequeno.svg'
import IconData from '../../../../../../../../../static/img/qma/IconData.svg'
import ImageNotFound from '../../../../../../../../../static/img/qma/semDados.svg'
import IconNumero from '../../../../../../../../../static/img/qma/IconNumero.svg'

export default {
  name: 'newHeader',
  props: ['templateid'],
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      dataQMACabecalho: [],
      dataFiltroQMACabecalho: [],
      itensAguardandoEnvio: [],
      buscaItem: '',
      imgTexto: IconCampoPequeno,
      imgData: IconData,
      novoItemDescricao: null,
      novoItemTipo: null,
      semDados: ImageNotFound,
      statusCabecalho: null,
      imgNumero: IconNumero,
      cadastros: false,
      addItensLimpaFiltro: false
    }
  },

  watch: {
    buscaItem (newvalue, oldvalue) {
      if (newvalue.trim() !== '') {
        this.BuscaItemlAdd(newvalue)
      } else {
        this.dataFiltroQMACabecalho = [...this.dataQMACabecalho]
        if (this.itensAguardandoEnvio.length > 0) {
          this.$nextTick(() => {
            this.restauraclicked(this.itensAguardandoEnvio)
          })
        }
      }
    }
  },
  updated () {
    // Este hook será executado sempre que o DOM for atualizado
    this.$nextTick(() => {
      if (this.itensAguardandoEnvio.length > 0) {
        this.restauraclicked(this.itensAguardandoEnvio) // Chama restauraclicked após atualização do DOM
        if (this.addItensLimpaFiltro === true) {
          this.identificarElementosClicados()
        }
      }
    })
  },
  mounted () {
    this.onLoad()
  },
  methods: {
    popUptAdd () {
      this.onLoad()
      this.$refs['add-novo-cabecalho'].show()
      this.itensAguardandoEnvio = []
      this.novoItemDescricao = null
      this.novoItemTipo = null
      this.cadastros = false
    },
    fecharPopUptAdd () {
      this.$refs['add-novo-cabecalho'].hide()
      this.itensAguardandoEnvio = []
      this.novoItemDescricao = null
      this.novoItemTipo = null
      this.cadastros = false
    },
    onLoad () {
      loading.push()
      qmaTemplateCabecalho.GetItensCabecalho(this.templateid)
        .then((Response) => {
          loading.pop()
          this.dataQMACabecalho = Response.data.data
          this.dataFiltroQMACabecalho = Response.data.data
          this.cadastros = false
        })
    },
    itenscabecalho () {
      loading.push()
      qmaTemplateCabecalho.GetStatusTipoCabecalho()
        .then((Response) => {
          loading.pop()
          this.statusCabecalho = Response.data
        })
    },
    ItemNovoParaLita () {
      this.itenscabecalho()
      this.cadastros = true
      setTimeout(() => {
      }, 1000)
      // let novoItem = {
      //   id: null,
      //   status: 1,
      //   descricao
      // }
    },
    BuscaItemlAdd (value) {
      this.dataFiltroQMACabecalho = this.dataQMACabecalho.filter((Element) => Element.descricao.toUpperCase().indexOf(value.toUpperCase()) > -1)
    },
    AdicionarIten (id) {
      let novoItem = {tipo: id.tipo, descricao: id.descricao, descricaoEdicao: 'AG. ENVIO - NOVO ITEM', edicao: true, nivelPrioridade: 0, templateId: this.templateid, status: 1, id: id.id, colorFonte: 'rgb(0, 55, 137)', colorStatus: 'rgb(212, 238, 253)', check: false, add: true}
      this.itensAguardandoEnvio.push(novoItem)
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.itensAguardandoEnvio = this.itensAguardandoEnvio.filter(item => item.id !== id.id)
      } else {
        div.classList.add('clicked')
      }
    },
    restauraclicked (Lista) {
      for (let j = 0; j < Lista.length; j++) {
        var div = document.getElementById(Lista[j].id)
        if (div != null) {
          div.classList.add('clicked')
        }
      }
    },
    identificarElementosClicados () {
      if (this.buscaItem === '') {
        var elementosClicados = []
        this.dataQMACabecalho.forEach(function (elemento) {
          var elementoHTML = document.getElementById(elemento.id)
          if (elementoHTML && elementoHTML.classList.contains('clicked')) {
            elementosClicados.push(elementoHTML.id)
          }
        })
        if (elementosClicados.length > 0) {
          this.addItem(elementosClicados)
        } else {
          toast.warning('Adicione pelo menos um item')
        }
      } else {
        this.addItensLimpaFiltro = true
        this.buscaItem = ''
      }
    },
    addItem (ids) {
      console.log(ids)
      this.datanewItens = {item: ids}
      this.$emit('salvarNovosItensCabecalho', this.datanewItens)
      this.$emit('AdicionarTableCabecalho', this.itensAguardandoEnvio)
      this.fecharPopUptAdd()
    },
    validaCampos () {
      if (!this.novoItemDescricao || this.novoItemDescricao.trim() === '') {
        return toast.warning('Informe a descrição do item')
      }

      if (this.novoItemTipo == null) {
        return toast.warning('Informe o tipo do item')
      }
      this.salvarNovoItem()
    },
    salvarNovoItem () {
      qmaTemplateCabecalho.PostNovoItemCabecalho({descricao: this.novoItemDescricao.trim(), tipo: this.novoItemTipo})
        .then((Response) => {
          loading.pop()
          this.novoItemDescricao = null
          this.novoItemTipo = null
          toast.success('Sucesso na criação')
          this.onLoad()
        })
        .catch((Error) => {
          loading.pop()
          toast.warning(Error.response.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/detailsTemplate/tabsTemplate/components/newHeader/newHeader.js